import moment from 'moment'
import { EStatus } from '../../src/utils/async'
import { Base_Dispatcher } from '../Base/Base.Dispatcher'
import { IDB_locationTimelineEventRead } from '../IDB/IDB.table.locationTimelineEvent'
import { Loca_SET_TIMELINE } from './Loca.constants'
import { Logg_event } from '../Logg/Logg.event'

export async function Loca_setTimeline(id: number) {
    Logg_event('Start', { label: 'location.setTimeline' })

    dispatchTimeline(EStatus.loading)

    let timeline = null

    try {
        timeline = await IDB_locationTimelineEventRead(id)
    } catch (error) {
        dispatchTimeline(EStatus.failure)
        return
    }

    // Account for no events in the local db. Possible if we've only just added the location
    if (timeline === undefined) {
        dispatchTimeline(EStatus.success, [])
        return
    }

    // TODO: We need to change the logic of the function to support the new unit logic
    // TODO: Move this to the React component and keep the date in its original state
    for (const event of timeline.events) {
        const now = moment()
        const time = moment(event.date)
        const displayTime = time.isAfter(now) ? now : time
        const timeAgo = displayTime.fromNow()

        event.timeAgo = timeAgo
    }

    dispatchTimeline(EStatus.success, timeline.events)
}

function dispatchTimeline(status: EStatus, events?: any) {
    Base_Dispatcher.dispatch({
        actionType: Loca_SET_TIMELINE,
        data: {
            status,
            events: events || [],
        },
    })
}
